import React, { useState } from "react";
import { Image as ImageIcon } from "lucide-react";

export default function UrlThumbnail({ url, sizeClass = "w-14 h-14", iconClass = "h-4 w-4" }) {
  const [errored, setErrored] = useState(false);
  return (
    <div className={`${sizeClass} rounded-md overflow-hidden bg-muted ring-1 ring-border flex items-center justify-center shrink-0`}>
      {errored ? (
        <ImageIcon className={`${iconClass} text-muted-foreground`} />
      ) : (
        <img
          src={url}
          alt=""
          className="w-full h-full object-cover"
          onError={() => setErrored(true)}
        />
      )}
    </div>
  );
}
